import React from 'react';
import Footer from '../../../../components/Footer';

/*
 This component is used for the Quest footer if "showFooter" is set to true
*/
export default () => <Footer />;
